import { SignupForm } from "../features/auth/components/SignupForm";

export const SignupPage = () => {
    return (
        <div className="px-6 pt-6">
            <SignupForm />
        </div>
    );
};
